import PropTypes from "prop-types";
import Image from "next/image";

import { Card, Typography, Grid } from "@/components/core";

export function CampaignCard({ sx, id, campaign, imageLink, imageAlt }: any) {
  return (
    <Card key={id}>
      <Grid
        sx={{
          padding: "20px",
          borderRadius: "10px",
          gap: "18px",
          width: "275px",
          ...sx,
        }}
      >
        <Grid.Item>
          <Image
            src={imageLink}
            alt={imageAlt || id}
            width={90}
            height={74}
            style={{ borderRadius: "6px", objectFit: "cover" }}
          />
        </Grid.Item>
        <Grid.Item xs>
          <Typography fontWeight={600}>{campaign}</Typography>
        </Grid.Item>
      </Grid>
    </Card>
  );
}

CampaignCard.propTypes = {
  sx: PropTypes.object,
  id: PropTypes.any,
  campaign: PropTypes.string.isRequired,
  imageLink: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
};
